module.exports = __webpack_public_path__ + "img/appAsset--compliance--flow-connector--blue.06ffdf88.svg";